export const urlUtils = {
  methods: {
    mapObjTypeToUrlPath(objectType, refNum) {
      let urlPath = '';
      switch (objectType) {
        case 'TIME_SHEET':
          urlPath = '/time-sheets/';
          break;
        case 'EXPENSE_REPORT':
          urlPath = '/expenses/';
          break;
        case 'ASSIGNMENT':
          urlPath = '/assignments/';
          break;
        case 'USER':
          urlPath = '/users/';
          break;
        default:
          console.warn(objectType + ' url is not implemented yet');
      }
      return urlPath != '' ? urlPath + refNum : urlPath;
    }
  }
};
